import 'styles/views/offers/pages/index/index.scss'
import ArticleCarousel from './components/article_carousel'

window.Offers = window.Offers || {}
window.Offers.Pages = window.Offers.Pages || {}
window.Offers.Pages.Index = {
  ArticleCarousel
}
